import type { ArtifactPreview } from "~/services/artifacts";
import { ArtifactShell } from "./ArtifactShell";
import { FileArtifactBody } from "./FileArtifactBody";

// Text artifacts are stored as files; the preview Lambda only ships
// `{file_name}`, so there's no inline content to render — we show the
// filename + a Download button (see FileArtifactBody).
export const TextArtifact = ({ preview }: { preview: ArtifactPreview }) => (
  <ArtifactShell preview={preview}>
    <FileArtifactBody preview={preview} />
  </ArtifactShell>
);
